import {
  Card,
  Grid,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { useMemo } from 'react';
// Data layer
import { faUser } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NATURAL_PERSON } from 'data-layer-cr/dist/constants/customerTypes';
import { Customer, Driver, LegalEntity } from 'data-layer-cr/dist/models';
import { dateFormat } from 'design-system';
import genderString from 'src/functions/genderString';
import { CustomerType } from 'src/models/helperTypes/CustomerItem';
import DescriptionItem from './DescriptionItem';

const { dateFromServerString } = dateFormat;

const useStyles = makeStyles(() => ({
  titleSection: { paddingBottom: 7, marginBottom: 20 },
  logo: { marginRight: 11 },
  titleText: {
    fontSize: 19,
    fontWeight: 900,
  },
  cardRoot: {
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 25,
    paddingRight: 20,
    borderRadius: 10,
    boxShadow: '0px 2px 15px rgba(0, 0, 0, 0.08)',
    maxWidth: ({ isMobile }: { isMobile: boolean }) =>
      isMobile ? '100%' : '500px',
    width: '100%',
  },
}));

type Props = {
  customerType: CustomerType;
  customer: Customer;
  legalEntity: LegalEntity;
  driver: Driver;
};

type ReferenceValue = {
  name: string;
  phone: string;
  email: string;
};

const CustomerResumeCard = ({
  customerType,
  customer,
  legalEntity,
  driver,
}: Props): JSX.Element => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles({ isMobile });
  const { name, email, phone } = useMemo((): ReferenceValue => {
    if (customerType === NATURAL_PERSON) {
      return {
        name: `${customer.firstName} ${customer.lastName}`,
        email: customer.email,
        phone: `+506 ${customer.phone}`,
      };
    }
    return {
      name: legalEntity.name,
      email: legalEntity.email,
      phone: `+506 ${legalEntity.phone}`,
    };
  }, [customerType, legalEntity, customer]);

  return (
    <Card className={classes.cardRoot} data-testid="customer-resume-card">
      <Grid container className={classes.titleSection}>
        <FontAwesomeIcon
          icon={faUser}
          size="2xl"
          color="#0D2E68"
          style={{ marginRight: 10 }}
        />
        <Typography className={classes.titleText} data-testid="title-text">
          Datos del contratante
        </Typography>
      </Grid>
      <Grid container>
        <Typography className={classes.titleText} data-testid="title-text">
          {name}
        </Typography>
      </Grid>
      <DescriptionItem
        data-testid="driver-birthdate-description"
        description="Fecha de nacimiento"
        value={dateFromServerString(driver.birthday)}
      />
      <DescriptionItem
        data-testid="driver-gender-description"
        description="Género"
        value={genderString(driver.gender)}
      />
      <DescriptionItem
        data-testid="phone-description"
        description="Celular"
        value={phone}
      />
      <DescriptionItem
        data-testid="email-description"
        description="Email"
        value={email}
      />
    </Card>
  );
};

export default CustomerResumeCard;
